import * as React from 'react';

import * as agui from 'arm-gui/dist/controls';
import { Utils, isAuth, NumberFormatter, domain, domainVal, i18n, DateFormatter } from 'arm-common';
import BtnDelete from '../shared/BtnDelete.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { connect } from 'react-redux';
import { isNullOrUndefined } from 'util';
import FamiglieProdottoAction from './famiglieProdottoActions'
import CategorieProdottoTable from '../categorieProdotto/categorieProdottoTable.jsx'
import Rest from '../../webapi/Rest';
import ApplicationData from '../../app/aApplicationData'
import { reject } from 'lodash';

class FamigliaProdottoDetails extends React.Component {
    constructor(props) {
        super(props),
            this.componentName = "[FamigliaProdottoDetails.jsx]"
        this.state = {
            showConfirmDelete: false,
        }
        this.deleteFamigliaProdotto = this.deleteFamigliaProdotto.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        let idFamiglia = null;

        if (isNullOrUndefined(this.props.location.state) || isNullOrUndefined(this.props.location.state.id)) {
            idFamiglia = this.props.famigliaProdotto.id;
        } else {
            idFamiglia = this.props.location.state.id;
        }

        this.props.getFamigliaProdottoDetails(idFamiglia);

    }

    deleteFamigliaProdotto() {

        console.log(this.componentName + ' deleteFamigliaProdotto');

        this.showConfirmDelete();
        this.props.deleteFamigliaProdotto(this.props.famigliaProdotto.id).then(
            resolve => {
                this.props.history.push({ pathname: '/famiglie/list' })
            },
            reject => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
            }
        );
        ;

    }
    showConfirmDelete() {
        console.log(this.componentName + ' showConfirmDelete');

        this.setState({ showConfirmDelete: !this.state.showConfirmDelete })

    }

    render() {
        return (
            <div className="card">
                <div className="card-header">
                    <h3> {i18n('ARM_CORE_PRODUCT.FAMIGLIE.DETTAGLIO_FAMIGLIA', 'Dettaglio Famiglia')} : {this.props.famigliaProdotto.nome} - id: {this.props.famigliaProdotto.id}</h3>
                </div>
                <div className="card-body">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="active" >
                            <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLI', 'Dettagli')}</a>
                        </li>
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.CATEGORIE') &&
                        <li className="nav-item">
                            <a className="nav-link " id="categorie-tab" data-toggle="tab" href="#categorie" role="tab" aria-controls="categorie" aria-selected="true">{i18n('ARM_CORE_PRODUCT.CATEGORIE.CATEGORIE', 'Categorie Prodotto')}</a>
                        </li> }
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                            <dl className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 ">
                                    {this.props.famigliaProdotto.imagePath ?
                                        <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className=" col-12 mt-2 ml-4" sizes="50x32" rel="icon" src={this.props.famigliaProdotto.imagePath ? Rest.createRestLink("document/download/" + this.props.famigliaProdotto.imagePath) : ""} alt="Card image cap" />
                                        : <h6 className="mt-5">{i18n('ARM_CORE_PRODUCT.IMAGINE.FAMIGLIA.PRODOTTO', 'Nessuna immagine legata a questa famiglia prodotto')}</h6>}
                                </div>
                                {/* <div className="row mt-3"> */}
                                <dl className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <dl className="row mt-4">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.AMBITO', 'Ambito')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.famigliaProdotto && this.props.famigliaProdotto.codAmbito ? ApplicationData.domainVal('AI_AMBITO_RAMO', this.props.famigliaProdotto.codAmbito, this.props.famigliaProdotto.codAmbito).desDom : "-"}</dd>
                                    </dl>
                                </dl>
                            </dl>
                            <div className="row mt-3">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.NOME', 'Nome')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.famigliaProdotto ? this.props.famigliaProdotto.nome : "-"}</dd>
                                <dt className="col-sm-2 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZINE', 'Descrizione')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.famigliaProdotto ? this.props.famigliaProdotto.descrizione : "-"}</dd>
                            </div>
                            <div className="row">

                                {/* <dt className="col-sm-2 col-4 ">{i18n('ARM_CORE_PRODUCT.SHARED.SINGLA', 'Sigla')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.famigliaProdotto ? this.props.famigliaProdotto.sigla : "-"}</dd> */}
                                <dt className="col-sm-2 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.famigliaProdotto ? this.props.famigliaProdotto.ordVis : "-"}</dd>
                            </div>

                            <dl className="row">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.INSERITO_DA', 'Inserito da')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.famigliaProdotto.insertUser}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento')}</dt>
                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.famigliaProdotto.insertDate)}</dd>
                            </dl>

                            <dl className="row">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.famigliaProdotto.updateUser}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica')}</dt>
                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.famigliaProdotto.updateDate)}</dd>
                            </dl>

                        </div>

                        <div className="tab-pane fade" id="categorie" role="tabpanel" aria-labelledby="categorie-tab">
                            <CategorieProdottoTable rows={this.props.famigliaProdotto.listCategorieProdotto} history={this.props.history} />
                        </div>
                    </div>
                </div>

                <div className="card-footer mb-2">
                    <div className="float-left">
                        {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                            <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" href="#/famiglie/create">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                        }
                        {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                            <BtnDelete onClick={this.showConfirmDelete} className="float-right" ></BtnDelete>
                        }
                    </div>
                    <agui.aButton bs="secondary" className="float-right mr-2" href="#/famiglie/list" >{i18n('ARM_CORE_PRODUCT.SHARED.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                </div>
                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteFamigliaProdotto}
                    onClose={this.showConfirmDelete} />
            </div>


        )
    }
}

function mapDispatchToProps(dispatch) {
    return {

        deleteFamigliaProdotto(id) {
            return dispatch(FamiglieProdottoAction.deleteFamiglia(id))
        },
        getFamigliaProdottoDetails(id) {
            return dispatch(FamiglieProdottoAction.getFamigliaDetails(id));
        },
        inizializzaNuovaFamiglia() {
            return dispatch(FamiglieProdottoAction.inizializzaNuovaFamiglia())
        }

    }
};

function mapStateToProps(state) {
    return {
        famigliaProdotto: state.famiglieProdotto.famigliaProdotto,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(FamigliaProdottoDetails)